import React from 'react';

const Bookmark: React.VFC = () => (
  <svg width="21" height="27" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.7917 0.375H3.20835C1.60419 0.375 0.306271 1.6875 0.306271 3.29167L0.291687 26.625L10.5 22.25L20.7084 26.625V3.29167C20.7084 1.6875 19.3959 0.375 17.7917 0.375ZM17.7917 22.25L10.5 19.0708L3.20835 22.25V3.29167H17.7917V22.25Z" fill="#333333" />
  </svg>
);

export default Bookmark;
